<template lang="pug">
RowMenu
  slot
</template>

<script>
/**
 * Columna "Acciones" de una tabla: agrupa sus RowAction en un desplegable.
 *
 * Antes las pintaba en fila, una al lado de la otra. Con cuatro o cinco
 * acciones por fila la columna competía en peso visual con los datos, y
 * como los botones no tienen texto, había que apuntarle a cada ícono para
 * saber qué hacía. Plegadas en un menú, la tabla muestra datos y las
 * acciones aparecen cuando se las pide, con su nombre escrito.
 *
 * El uso no cambió: sigue siendo RowActions con RowAction adentro.
 */
export default {
  name: 'RowActions',
};
</script>
